import FollowupQuestionsField from './FollowupQuestionsField.component';

export default FollowupQuestionsField;